import React from 'react';
import '../../css/PreviewPDF.css';
import { Client, TripInfo, ItineraryItem } from '../../types/Quotation';
import SummaryBar from './SummaryBar';
import InclusionIcons from './InclusionIcons';

interface TripSummaryProps {
  client: Client;
  tripInfo: TripInfo;
  itinerary: ItineraryItem[];
  highlights: string;
}

const TripSummary: React.FC<TripSummaryProps> = ({ client, tripInfo, itinerary, highlights }) => (
  <div className="pdf-header-container">
    <div>
      <h2>
        <span className="client-name">{client.name}</span>
        <span className="sub-text">'s Customized Quotation for</span>
      </h2>
    </div>

    <div className="trip-title-banner">
      <h1>{tripInfo.title}</h1>
    </div>

    <SummaryBar client={client} tripInfo={tripInfo} />

    <h2>Inclusions</h2>
    <InclusionIcons inclusions={tripInfo.inclusions} />

    <p className="inclusion-disclaimer">
      *Inclusions based on itinerary and availability. Final confirmation subject to booking details.
    </p>
  </div>
);

export default TripSummary;
